/**
 * Cave Canem theme JS — vanilla rewrite (PERF-04 #24).
 *
 * Replaces the previous jQuery implementation so the jQuery / Bootstrap-JS /
 * MetisMenu / Slick / Owl Carousel stack could be removed from
 * layout/theme.liquid (~263 KB of script). Only handlers whose target
 * elements exist in the theme survived the rewrite; the original template's
 * dead slider inits and checkout toggles were dropped.
 */

document.addEventListener('DOMContentLoaded', function () {
  ////////////////////////////////////////////////////
  // Helpers
  function addClassAll(selector, cls) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.add(cls);
    });
  }
  function removeClassAll(selector, cls) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.classList.remove(cls);
    });
  }
  function onClickAll(selector, handler) {
    document.querySelectorAll(selector).forEach(function (el) {
      el.addEventListener('click', handler);
    });
  }

  ////////////////////////////////////////////////////
  // 01. Desktop menu — open one submenu at a time (#list-menu)
  var desktopMenu = document.querySelector('#list-menu');
  if (desktopMenu) {
    desktopMenu.addEventListener('click', function (event) {
      var link = event.target.closest('.top-link');
      if (!link) return;

      var parentLi = link.closest('li');
      var submenu = parentLi.querySelector('.submenus');

      if (!submenu) return;

      document.querySelectorAll('.has-dropdown').forEach(function (item) {
        item.classList.remove('open');
        var itemSubmenu = item.querySelector('.submenus');
        if (itemSubmenu) {
          itemSubmenu.style.display = 'none';
        }
      });

      parentLi.classList.add('open');
      submenu.style.display = 'block';
    });
  }

  ////////////////////////////////////////////////////
  // 02. Search overlay
  onClickAll('.search-toggle', function () {
    addClassAll('.header__search', 'search-opened');
    addClassAll('.body-overlay', 'opened');
  });
  onClickAll('.header__search-btn-close', function () {
    removeClassAll('.header__search', 'search-opened');
    removeClassAll('.body-overlay', 'opened');
  });

  ////////////////////////////////////////////////////
  // 03. Mobile menu drawer (.extra__info)
  onClickAll('.mobile-menu-toggle', function () {
    addClassAll('.extra__info', 'info-opened');
    addClassAll('.body-overlay', 'opened');
  });
  onClickAll('.extra__info-close-btn', function () {
    removeClassAll('.extra__info', 'info-opened');
    removeClassAll('.body-overlay', 'opened');
  });
  onClickAll('.mob_hide .has-dropdown, #slider_nav', function () {
    addClassAll('.extra__info', 'info-opened');
    addClassAll('.body-overlay', 'opened');
  });

  // Overlay click closes the search, the drawer, and any open desktop submenu
  onClickAll('.body-overlay', function () {
    removeClassAll('.header__search', 'search-opened');
    removeClassAll('.extra__info', 'info-opened');
    removeClassAll('.body-overlay', 'opened');
    document.querySelectorAll('.submenus').forEach(function (el) {
      el.style.display = 'none';
    });
  });

  ////////////////////////////////////////////////////
  // 04. Sticky header
  var stickyHeader = document.getElementById('header-sticky');
  if (stickyHeader) {
    window.addEventListener(
      'scroll',
      function () {
        if (window.scrollY < 100) {
          stickyHeader.classList.remove('sticky');
        } else {
          stickyHeader.classList.add('sticky');
        }
      },
      { passive: true }
    );
  }

  ////////////////////////////////////////////////////
  // 05. Mobile menu accordion (replaces metisMenu)
  // Submenus start collapsed via CSS in sections/header.liquid; clicking a
  // parent item toggles it. aria-expanded drives the existing arrow styling
  // in style.css (.side-mobile-menu ... a[aria-expanded=true]).
  document.querySelectorAll('#mobile-menu-active li.has-dropdown > a').forEach(function (anchor) {
    anchor.setAttribute('aria-expanded', 'false');
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      var li = anchor.parentElement;
      var submenu = li.querySelector('.submenu');
      if (!submenu) return;
      var isOpen = anchor.getAttribute('aria-expanded') === 'true';
      submenu.style.display = isOpen ? 'none' : 'block';
      anchor.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    });
  });
});
